/**
 * WISHLIST SMART API - ROUND 5 KNOWN LEAD IDENTITY + SMART ENDPOINT (V16)
 *
 * Amaç:
 * - Guest kullanıcı login olunca yeniden ADD event yazma.
 * - Guest kayıtları deleteWishlist ile silip REMOVE event yazma.
 * - Guest Wishlist kayıtlarını updateWishlist ile sessizce customer'a bağla.
 * - Guest WishlistEvent kayıtlarını updateWishlistEvent ile sessizce customer'a bağla.
 * - Eğer customer'da aynı ürün zaten varsa guest duplicate kaydı silentDelete ile sessiz sil.
 * - pingConversion tarafında customer ile bulunamazsa session fallback yap.
 * - pingConversion(storageKey, source) ile CART event source bilgisini backend'e gönderir.
 * - markConvertedWishlist mutation response içinde sadece success sorgula.
 */

(function () {
  if (window.__LS_WISHLIST_SMART_API_V16_LEAD_IDENTITY__) return;

  window.__LS_WISHLIST_SMART_API_V18_SILENT_MOVE_TO_CART__ = true;
  window.__LS_WISHLIST_SMART_API_V16_LEAD_IDENTITY__ = true;
  window.__LS_WISHLIST_SMART_API_V15_SOURCE__ = true;
  window.__LS_WISHLIST_SMART_API_V14_FIXED__ = true;
  window.__LS_WISHLIST_SMART_API_V14__ = true;
  window.__LS_WISHLIST_SMART_API_V13__ = true;

  const LOCAL_KEY = "wishlist";
  const SID_KEY = "wl_sid";
  const LEAD_EMAIL_KEYS = ["lsw_lead_email", "wl_lead_email"];

  const getConfiguredApiBase = () => {
    try {
      if (window.__LS_WISHLIST_API_BASE__) {
        return String(window.__LS_WISHLIST_API_BASE__).replace(/\/$/, "");
      }

      if (window.LSW_CONVERSION_CONFIG && window.LSW_CONVERSION_CONFIG.apiBase) {
        return String(window.LSW_CONVERSION_CONFIG.apiBase).replace(/\/$/, "");
      }

      const configNode = document.getElementById("lsw-conversion-config");
      if (configNode && configNode.textContent) {
        const parsed = JSON.parse(configNode.textContent || "{}");
        if (parsed.apiBase) return String(parsed.apiBase).replace(/\/$/, "");
      }
    } catch {}

    return "https://gemini-wishlist.gadget.app";
  };

  const getGadgetEndpoint = () => `${getConfiguredApiBase()}/api/graphql`;

  const log = (msg, data) => {
    console.log(
      `%c📊 SmartAnalytics: ${msg}`,
      "color: #00e676; font-weight: bold;",
      data || ""
    );
  };

  const err = (msg, data) => {
    console.error(
      `%c📊 SmartAnalytics ERROR: ${msg}`,
      "color: #ff4444; font-weight: bold;",
      data || ""
    );
  };

  const getSid = () => {
    let sid = localStorage.getItem(SID_KEY);

    if (!sid) {
      sid = "sid_" + Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem(SID_KEY, sid);
    }

    return sid;
  };

  const getCustomerData = () => {
    if (window.ShopifyCustomerData && window.ShopifyCustomerData.id) {
      return {
        id: String(window.ShopifyCustomerData.id || ""),
        name: window.ShopifyCustomerData.name || "",
        email: window.ShopifyCustomerData.email || "",
      };
    }

    if (
      window.__SHOPIFY_CUSTOMER_ID__ &&
      window.__SHOPIFY_CUSTOMER_ID__ !== "null"
    ) {
      return {
        id: String(window.__SHOPIFY_CUSTOMER_ID__),
        name: window.__SHOPIFY_CUSTOMER_NAME__ || "",
        email: window.__SHOPIFY_CUSTOMER_EMAIL__ || "",
      };
    }

    if (
      window.Shopify &&
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.customerId
    ) {
      return {
        id: String(window.ShopifyAnalytics.meta.page.customerId),
        name: "",
        email: "",
      };
    }

    return null;
  };


  const getCapturedLeadEmail = () => {
    for (const key of LEAD_EMAIL_KEYS) {
      try {
        const value = localStorage.getItem(key);
        if (value && String(value).includes("@")) return String(value).trim().toLowerCase();
      } catch {}
    }
    return "";
  };

  const setCapturedLeadEmail = (email) => {
    const clean = String(email || "").trim().toLowerCase();
    if (!clean || !clean.includes("@")) return "";
    for (const key of LEAD_EMAIL_KEYS) {
      try { localStorage.setItem(key, clean); } catch {}
    }
    return clean;
  };

  window.LSW_WISHLIST_IDENTITY = window.LSW_WISHLIST_IDENTITY || {};
  window.LSW_WISHLIST_IDENTITY.getCapturedLeadEmail = getCapturedLeadEmail;
  window.LSW_WISHLIST_IDENTITY.setCapturedLeadEmail = setCapturedLeadEmail;

  window.addEventListener("lsw:lead-email-captured", (event) => {
    const email = event && event.detail ? event.detail.email : "";
    setCapturedLeadEmail(email);
    setTimeout(() => {
      try {
        if (window.WishlistAPI && typeof window.WishlistAPI.syncLeadEmail === "function") {
          window.WishlistAPI.syncLeadEmail(email);
        }
      } catch {}
    }, 120);
  });

  const normalizeLocalItem = (item) => {
    if (typeof item === "string") {
      const parts = item.split("::");
      const handle = parts[0] || "";
      const variantId = parts[1] || "";

      return {
        storageKey: item,
        handle,
        variantId,
        price: 0,
        title: "Unknown",
        image: "",
      };
    }

    return {
      storageKey: item.storageKey || "",
      handle: item.handle || "",
      variantId: item.variantId || "",
      price: item.price || 0,
      title: item.title || "Unknown",
      image: item.image || "",
    };
  };

  const readLocalWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(LOCAL_KEY) || "[]");
    } catch {
      return [];
    }
  };

  const writeLocalWishlist = (list) => {
    try {
      localStorage.setItem(LOCAL_KEY, JSON.stringify(list || []));
    } catch {}
  };

  const removeLocalWishlist = () => {
    try {
      localStorage.removeItem(LOCAL_KEY);
    } catch {}
  };

  async function sendGadgetRequest(query, variables) {
    try {
      const res = await fetch(getGadgetEndpoint(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables,
        }),
      });

      const json = await res.json();

      if (json.errors) {
        console.warn("API Warning:", json.errors[0]?.message || json.errors);
        return {
          data: null,
          errors: json.errors,
        };
      }

      return json;
    } catch (e) {
      console.warn("Network Error", e);
      return {
        data: null,
        error: e,
      };
    }
  }

  async function findWishlistByFilters(filters) {
    if (!Array.isArray(filters) || filters.length === 0) {
      return null;
    }

    const query = `
      query FindWishlistRecord($filter: [WishlistFilter!]) {
        wishlists: Wishlists(first: 1, filter: $filter) {
          edges {
            node {
              id
              storageKey
              sessionId
              customerIdRaw
              customerEmail
              convertedAt
              purchasedAt
            }
          }
        }
      }
    `;

    for (const filter of filters) {
      try {
        const res = await sendGadgetRequest(query, {
          filter: [filter],
        });

        const node = res.data?.wishlists?.edges?.[0]?.node;

        if (node?.id) {
          return node;
        }
      } catch {}
    }

    return null;
  }

  const normalizeConversionSource = (source) => {
    const raw = String(source || "").trim();

    if (raw === "wishlist_page") return "wishlist_page";
    if (raw === "product_page_wishlisted") return "product_page_wishlisted";
    if (raw === "product_popup_nudge") return "product_popup_nudge";
    if (raw === "cart_remove_rescue") return "cart_remove_rescue";

    return "unknown";
  };

  window.WishlistAPI = {
    silentDeleteById: async (id) => {
      if (!id) {
        return {
          success: false,
          reason: "missing_id",
        };
      }

      const query = `
        mutation SilentDeleteWishlist($id: GadgetID!) {
          silentDeleteWishlist(id: $id) {
            success
          }
        }
      `;

      return await sendGadgetRequest(query, {
        id,
      });
    },



    silentRemove: async (storageKey) => {
      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const sid = getSid();
      const leadEmail = getCapturedLeadEmail();

      if (!storageKey) {
        return {
          success: false,
          reason: "missing_storageKey",
        };
      }

      // Guest local wishlist de temizlensin; ama REMOVE event yazılmasın.
      try {
        let list = readLocalWishlist();
        list = list.filter((i) => {
          return (typeof i === "string" ? i : i.storageKey) !== storageKey;
        });
        writeLocalWishlist(list);
      } catch {}

      const filters = [];

      if (cid) {
        filters.push({
          storageKey: { equals: storageKey },
          customerIdRaw: { equals: cid },
        });
      }

      if (sid) {
        filters.push({
          storageKey: { equals: storageKey },
          sessionId: { equals: sid },
          customerIdRaw: { isSet: false },
        });
      }

      if (leadEmail) {
        filters.push({
          storageKey: { equals: storageKey },
          customerEmail: { equals: leadEmail },
        });
      }

      try {
        const record = await findWishlistByFilters(filters);

        if (record?.id) {
          await window.WishlistAPI.silentDeleteById(record.id);
          log(`🧹 Move to cart sonrası wishlist kaydı sessiz silindi | storageKey=${storageKey}`);
        }

        return {
          success: true,
          silent: true,
          deleted: Boolean(record?.id),
        };
      } catch (e) {
        err("Wishlist silentRemove hatası:", e);

        return {
          success: false,
          error: e,
        };
      }
    },

    updateGuestEventsToCustomer: async (sessionId, customer) => {
      const cid = customer ? String(customer.id || "") : "";
      const cEmail = customer ? String(customer.email || "") : getCapturedLeadEmail();

      if (!cid || !sessionId) {
        return {
          success: false,
          reason: "missing_customer_or_session",
        };
      }

      const findEventsQuery = `
        query FindGuestWishlistEvents($filter: [WishlistEventFilter!]) {
          events: WishlistEvents(first: 250, filter: $filter) {
            edges {
              node {
                id
                eventType
                sessionId
                customerIdRaw
                customerEmail
              }
            }
          }
        }
      `;

      const eventFilter = [
        {
          sessionId: {
            equals: sessionId,
          },
          customerIdRaw: {
            isSet: false,
          },
        },
      ];

      try {
        const findRes = await sendGadgetRequest(findEventsQuery, {
          filter: eventFilter,
        });

        const events = findRes.data?.events?.edges || [];

        if (events.length === 0) {
          log("Sessiz event merge: guest WishlistEvent bulunamadı");

          return {
            success: true,
            updated: 0,
          };
        }

        log(`🔄 Sessiz event merge başladı: ${events.length} event customer'a bağlanıyor...`);

        for (const { node } of events) {
          if (!node?.id) continue;

          const updateEventQuery = `
            mutation UpdateGuestWishlistEvent(
              $id: GadgetID!,
              $cid: String,
              $cEmail: String
            ) {
              updateWishlistEvent(
                id: $id,
                WishlistEvent: {
                  customerIdRaw: $cid,
                  customerEmail: $cEmail
                }
              ) {
                success
                WishlistEvent {
                  id
                }
              }
            }
          `;

          await sendGadgetRequest(updateEventQuery, {
            id: node.id,
            cid,
            cEmail,
          });
        }

        log("✅ Guest WishlistEvent kayıtları customer'a bağlandı");

        return {
          success: true,
          updated: events.length,
        };
      } catch (e) {
        err("Guest WishlistEvent merge hatası:", e);

        return {
          success: false,
          error: e,
        };
      }
    },

    mergeGuestToCustomer: async (sessionId, customer) => {
      const cid = customer ? String(customer.id || "") : "";
      const cName = customer ? String(customer.name || "") : "";
      const cEmail = customer ? String(customer.email || "") : getCapturedLeadEmail();

      if (!cid || !sessionId) {
        return {
          success: false,
          reason: "missing_customer_or_session",
        };
      }

      const findGuestQuery = `
        query FindGuestWishlists($filter: [WishlistFilter!]) {
          wishlists: Wishlists(first: 250, filter: $filter) {
            edges {
              node {
                id
                storageKey
                variantId
                handle
              }
            }
          }
        }
      `;

      const guestFilter = [
        {
          sessionId: {
            equals: sessionId,
          },
          customerIdRaw: {
            isSet: false,
          },
        },
      ];

      try {
        const findRes = await sendGadgetRequest(findGuestQuery, {
          filter: guestFilter,
        });

        const guestRecords = findRes.data?.wishlists?.edges || [];

        if (guestRecords.length === 0) {
          log("Sessiz merge: backend'de guest kayıt bulunamadı");

          return {
            success: true,
            merged: 0,
          };
        }

        log(`🔄 Sessiz merge başladı: ${guestRecords.length} guest kayıt kontrol ediliyor...`);

        for (const { node } of guestRecords) {
          if (!node?.id || !node?.storageKey) continue;

          const findCustomerDuplicateQuery = `
            query FindCustomerDuplicate($filter: [WishlistFilter!]) {
              wishlists: Wishlists(first: 1, filter: $filter) {
                edges {
                  node {
                    id
                    storageKey
                  }
                }
              }
            }
          `;

          const duplicateFilter = [
            {
              storageKey: {
                equals: node.storageKey,
              },
              customerIdRaw: {
                equals: cid,
              },
            },
          ];

          const duplicateRes = await sendGadgetRequest(findCustomerDuplicateQuery, {
            filter: duplicateFilter,
          });

          const existingCustomerRecord =
            duplicateRes.data?.wishlists?.edges?.[0]?.node || null;

          if (existingCustomerRecord?.id) {
            log(
              `🧹 Duplicate bulundu, guest kayıt sessiz siliniyor | storageKey=${node.storageKey}`
            );

            await window.WishlistAPI.silentDeleteById(node.id);
            continue;
          }

          const updateQuery = `
            mutation MergeWishlistToCustomer(
              $id: GadgetID!,
              $cid: String,
              $cName: String,
              $cEmail: String
            ) {
              updateWishlist(
                id: $id,
                Wishlist: {
                  customerIdRaw: $cid,
                  customerName: $cName,
                  customerEmail: $cEmail
                }
              ) {
                success
                Wishlist {
                  id
                  storageKey
                }
              }
            }
          `;

          await sendGadgetRequest(updateQuery, {
            id: node.id,
            cid,
            cName,
            cEmail,
          });

          log(`✅ Guest kayıt customer'a bağlandı | storageKey=${node.storageKey}`);
        }

        return {
          success: true,
          merged: guestRecords.length,
        };
      } catch (e) {
        err("Sessiz merge hatası:", e);

        return {
          success: false,
          error: e,
        };
      }
    },

    init: async () => {
      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const sid = getSid();

      const localData = readLocalWishlist();

      if (cid) {
        log("🔄 Customer login tespit edildi. Guest kayıtlar sessizce customer'a bağlanıyor...");

        await window.WishlistAPI.mergeGuestToCustomer(sid, customer);

        await window.WishlistAPI.updateGuestEventsToCustomer(sid, customer);

        if (localData.length > 0) {
          removeLocalWishlist();
          log("✅ Guest localStorage temizlendi. Sahte ADD/REMOVE event yazılmadı.");
        }

        return;
      }

      if (!cid && localData.length > 0) {
        const cloudKeys = await window.WishlistAPI.get();

        const itemsToSync = localData.filter((item) => {
          const normalized = normalizeLocalItem(item);
          return normalized.storageKey && !cloudKeys.includes(normalized.storageKey);
        });

        if (itemsToSync.length > 0) {
          log(`🔄 Guest sync: ${itemsToSync.length} ürün backend'e gönderiliyor...`);

          for (const item of itemsToSync) {
            const normalized = normalizeLocalItem(item);

            if (!normalized.storageKey) continue;

            await window.WishlistAPI.add({
              handle: normalized.handle,
              variantId: normalized.variantId,
              storageKey: normalized.storageKey,
              price: normalized.price,
              title: normalized.title,
              image: normalized.image,
            });
          }

          log("✅ Guest sync tamamlandı.");
        }
      }
    },

    get: async () => {
      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const cEmail = customer ? String(customer.email || "") : getCapturedLeadEmail();
      const sid = getSid();

      let filter = {};

      if (cid) {
        filter = {
          customerIdRaw: {
            equals: cid,
          },
        };
      } else {
        filter = {
          sessionId: {
            equals: sid,
          },
          customerIdRaw: {
            isSet: false,
          },
        };
      }

      const query = `
        query GetWishlistKeys($filter: [WishlistFilter!]) {
          wishlists: Wishlists(first: 250, filter: $filter) {
            edges {
              node {
                storageKey
              }
            }
          }
        }
      `;

      try {
        const res = await sendGadgetRequest(query, {
          filter: [filter],
        });

        if (res.errors) {
          throw new Error("GraphQL Error");
        }

        return res.data?.wishlists?.edges?.map((e) => e.node.storageKey) || [];
      } catch (e) {
        const list = readLocalWishlist();
        return list.map((i) => (typeof i === "string" ? i : i.storageKey));
      }
    },

    add: async (payload) => {
      let handle;
      let variantId;
      let storageKey;
      let price;
      let title;
      let image;

      if (typeof payload === "string") {
        handle = arguments[0];
        variantId = arguments[1];
        storageKey = arguments[2];
        price = 0;
        title = "";
        image = "";
      } else {
        handle = payload.handle || "";
        variantId = payload.variantId || "";
        storageKey = payload.storageKey || "";
        price = payload.price || 0;
        title = payload.title || "";
        image = payload.image || "";
      }

      if (!storageKey) {
        return {
          success: false,
          reason: "missing_storageKey",
        };
      }

      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const cName = customer ? String(customer.name || "") : "";
      const cEmail = customer ? String(customer.email || "") : getCapturedLeadEmail();
      const sid = getSid();

      if (!cid) {
        let list = readLocalWishlist();

        const exists = list.some((i) => {
          return (typeof i === "string" ? i : i.storageKey) === storageKey;
        });

        if (!exists) {
          list.push({
            storageKey,
            handle,
            variantId,
            price,
            title,
            image,
            customerEmail: getCapturedLeadEmail(),
            addedAt: Date.now(),
          });

          writeLocalWishlist(list);
        }
      }

      const query = `
        mutation AddWishlistItem(
          $handle: String,
          $vid: String,
          $key: String,
          $cid: String,
          $sid: String,
          $price: Float,
          $title: String,
          $img: String,
          $cName: String,
          $cEmail: String
        ) {
          createWishlist(
            Wishlist: {
              handle: $handle,
              variantId: $vid,
              storageKey: $key,
              customerIdRaw: $cid,
              sessionId: $sid,
              productPrice: $price,
              productTitle: $title,
              productImage: $img,
              customerName: $cName,
              customerEmail: $cEmail
            }
          ) {
            success
            Wishlist {
              id
            }
          }
        }
      `;

      const safeVid = variantId || null;

      return await sendGadgetRequest(query, {
        handle,
        vid: safeVid,
        key: storageKey,
        cid,
        sid,
        price,
        title,
        img: image,
        cName,
        cEmail,
      });
    },

    remove: async (storageKey) => {
      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const sid = getSid();

      if (!storageKey) {
        return {
          success: false,
          reason: "missing_storageKey",
        };
      }

      if (!cid) {
        let list = readLocalWishlist();

        list = list.filter((i) => {
          return (typeof i === "string" ? i : i.storageKey) !== storageKey;
        });

        writeLocalWishlist(list);
      }

      let filter = {};

      if (cid) {
        filter = {
          storageKey: {
            equals: storageKey,
          },
          customerIdRaw: {
            equals: cid,
          },
        };
      } else {
        filter = {
          storageKey: {
            equals: storageKey,
          },
          sessionId: {
            equals: sid,
          },
          customerIdRaw: {
            isSet: false,
          },
        };
      }

      const findQuery = `
        query FindWishlistForDelete($filter: [WishlistFilter!]) {
          wishlists: Wishlists(first: 1, filter: $filter) {
            edges {
              node {
                id
              }
            }
          }
        }
      `;

      try {
        const findRes = await sendGadgetRequest(findQuery, {
          filter: [filter],
        });

        const id = findRes.data?.wishlists?.edges?.[0]?.node?.id;

        if (id) {
          const delQuery = `
            mutation DeleteWishlistItem($id: GadgetID!) {
              deleteWishlist(id: $id) {
                success
              }
            }
          `;

          await sendGadgetRequest(delQuery, {
            id,
          });
        }
      } catch (e) {
        err("Wishlist remove hatası:", e);
      }

      return {
        success: true,
      };
    },

    syncLeadEmail: async (email) => {
      const clean = setCapturedLeadEmail(email);
      const sid = getSid();
      if (!clean || !sid) return { success: false, reason: "missing_email_or_session" };

      const query = `
        query FindSessionWishlists($filter: [WishlistFilter!]) {
          wishlists: Wishlists(first: 250, filter: $filter) {
            edges { node { id customerEmail } }
          }
        }
      `;

      try {
        const res = await sendGadgetRequest(query, {
          filter: [{ sessionId: { equals: sid }, customerIdRaw: { isSet: false } }],
        });

        const records = res.data?.wishlists?.edges || [];
        for (const { node } of records) {
          if (!node?.id || node.customerEmail === clean) continue;
          await sendGadgetRequest(`
            mutation UpdateWishlistLeadEmail($id: GadgetID!, $email: String) {
              updateWishlist(id: $id, Wishlist: { customerEmail: $email }) { success }
            }
          `, { id: node.id, email: clean });
        }

        return { success: true, updated: records.length };
      } catch (e) {
        err("Lead email sync hatası:", e);
        return { success: false, error: e };
      }
    },

    pingConversion: async (storageKey, source = "unknown") => {
      const customer = getCustomerData();
      const cid = customer ? String(customer.id || "") : null;
      const cEmail = customer ? String(customer.email || "") : getCapturedLeadEmail();
      const sid = getSid();
      const safeSource = normalizeConversionSource(source);

      if (!storageKey) {
        return {
          success: false,
          reason: "missing_storageKey",
        };
      }

      const filters = [];

      if (cid) {
        filters.push({
          storageKey: {
            equals: storageKey,
          },
          customerIdRaw: {
            equals: cid,
          },
        });
      }

      if (cEmail) {
        filters.push({
          storageKey: {
            equals: storageKey,
          },
          customerEmail: {
            equals: cEmail,
          },
        });
      }

      if (sid) {
        filters.push({
          storageKey: {
            equals: storageKey,
          },
          sessionId: {
            equals: sid,
          },
        });
      }

      try {
        const found = await findWishlistByFilters(filters);

        if (!found?.id) {
          console.log("🛒 Wishlist CART conversion eşleşme bulunamadı:", {
            storageKey,
            source: safeSource,
            cid,
            cEmail,
            sid,
          });

          return {
            success: false,
            reason: "wishlist_record_not_found",
          };
        }

        const mutation = `
          mutation MarkConverted($id: GadgetID!, $source: String) {
            markConvertedWishlist(id: $id, source: $source) {
              success
            }
          }
        `;

        const markRes = await sendGadgetRequest(mutation, {
          id: found.id,
          source: safeSource,
        });

        if (markRes.errors) {
          return {
            success: false,
            reason: "markConverted_graphql_error",
            errors: markRes.errors,
          };
        }

        const success = Boolean(markRes.data?.markConvertedWishlist?.success);

        if (success) {
          console.log("✅ Wishlist CART conversion yazıldı:", {
            storageKey,
            source: safeSource,
            wishlistId: found.id,
          });
        }

        return {
          success,
          id: found.id,
          source: safeSource,
        };
      } catch (e) {
        err("pingConversion hatası:", e);

        return {
          success: false,
          error: e,
        };
      }
    },
  };

  const boot = () => {
    setTimeout(() => {
      if (window.WishlistAPI && typeof window.WishlistAPI.init === "function") {
        window.WishlistAPI.init();
      }
    }, 80);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();